import { useTranslation } from 'react-i18next'

const Forbidden = () => {
  const { t } = useTranslation()
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <div className="rounded-2xl border border-red-200 bg-red-50 p-8">
        <h1 className="text-2xl font-bold text-red-700">{t('accessControl.forbiddenTitle')}</h1>
        <p className="mt-2 text-sm text-red-700/90">
          {t('accessControl.forbiddenDescription')}
        </p>
      </div>
    </div>
  )
}

export default Forbidden

